<script lang="ts">
    
    import { Swiper, Navigation } from 'swiper';
    import { onDestroy, onMount, setContext } from 'svelte';
    import type { Fn } from '../global';

    Swiper.use([Navigation]);

    const slidesMap = new Map<HTMLElement, Fn>();

    export let value: any = null;

    let needUpdate = true;
    let swiperContainer: HTMLElement;
    let prevBtn: HTMLElement;
    let nextBtn: HTMLElement;
    let swiper: Swiper;
    let inTransition: boolean = false;

    setContext('registerSlide', (slideEl: HTMLElement, getValue: Fn) => {
        slidesMap.set(slideEl, getValue);
        updateValue();
    });

    setContext('unregisterSlide', (slideEl: HTMLElement) => {
        slidesMap.delete(slideEl);
    });

    onMount(() => {

        swiper = new Swiper(swiperContainer, {
            loop: true,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            on: {
                slideChange() {
                    needUpdate = true;
                    updateValue();
                },
                slideChangeTransitionStart() {
                    inTransition = true;
                },
                slideChangeTransitionEnd() {
                    inTransition = false;
                },
            }
        });

        updateValue();

    });

    onDestroy(() => {
        swiper?.destroy();
    });

    function updateValue() {
        if (!swiper || !needUpdate) {
            return;
        }
        needUpdate = false;
        const currentSlideElement = swiper.slides[swiper.realIndex + 1] as HTMLElement;
        value = slidesMap.get(currentSlideElement)?.();
    }

</script>

<style lang="scss">

    @use '../variables';

    .slide-select {
        display: flex;
        align-items: center;
        border: 2px solid var(--color-secondary);
        border-radius: 3px;
    }

    .nav-btn {
        position: relative;
        z-index: 2;
        width: 3rem;
        height: 3rem;
        border: none;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;

        img {
            width: 2rem;
            height: 2rem;
            object-fit: contain;
        }

        &.prev {
            transform: scaleX(-1);
        }

        &.in-transition {

            img {
                opacity: 0.2;
            }

        }
    }

    .swiper-container {
        width: calc(100% - 6rem);
    }

    @media (max-width: variables.$big-phone-width) {

        .nav-btn {
            width: 2rem;
            height: 2rem;

            img {
                width: 1rem;
                height: 1rem;
            }
        }

    }


</style>

<div class="slide-select">

    <button type="button" class="nav-btn prev" class:in-transition={inTransition} bind:this={prevBtn}>
        <img src="/images/angle.png" alt="<">
    </button>

    <div class="swiper-container" bind:this={swiperContainer}>
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
    </div>

    <button type="button" class="nav-btn next" class:in-transition={inTransition} bind:this={nextBtn}>
        <img src="/images/angle.png" alt=">">
    </button>

</div>

